module.exports = __webpack_public_path__ + "img/85200.92f4ecff.jpg";